import { isPlainObject } from 'lodash'

import { APIRequest } from 'src/data/common/type'

import { API } from './BaseAPI'
import { PersistService } from './PersistService'

export class PrivateAppAPI {
  static isUSWebsite = new URLSearchParams(window.location.search).get('market') ?  new URLSearchParams(window.location.search).get('market') === 'US' : PersistService.fetch('market', 'local') === 'US'

  static url = (PrivateAppAPI.isUSWebsite ? process.env.REACT_APP_PRIVATE_APP_API_US : process.env.REACT_APP_PRIVATE_APP_API)
  static api = new API(PrivateAppAPI.url)

  static async request(data: APIRequest): Promise<any> {
    const params = {
      id: PersistService.fetch('customer_guid'),
      customer_hmac: PersistService.fetch('customer_hmac'),
      email: PersistService.fetch('customer_email'),
      source: 'myaccount',
      ...data.params,
    }

    return this.api
      .call({
        ...data,
        params,
        headers: {
          ...data.headers,
        },
      })
      .then((response) =>
        isPlainObject(response) && 'payload' in response
          ? response.payload
          : response
      )
  }
}
